import { render, staticRenderFns } from "./diaload.vue?vue&type=template&id=c2080b30&scoped=true&"
import script from "./diaload.vue?vue&type=script&lang=js&"
export * from "./diaload.vue?vue&type=script&lang=js&"
import style0 from "./diaload.vue?vue&type=style&index=0&id=c2080b30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2080b30",
  null
  
)

export default component.exports